import GridComponent from '../../component/grid/GridComponent.component';
import Card from '../../component/card/Card.component';
import Grid from '@material-ui/core/Grid';
import ButtonLink from '../../component/buttton/ButtonLink.component';
import Router from './Security.container';
import { Container } from '../../component/container/Container';
import { BiChevronRight } from 'react-icons/bi';

export default function NotificationComponent() {
  return (
    <Container margin='0px 0px 40px 0px'>
      <GridComponent spacing={2}>
        <Grid item>
          <ButtonLink
            title='Cadastrar Funcionalidade'
            link='/seguranca/funcionalidade'
            icon={<BiChevronRight />}
          />
        </Grid>
        <Grid item>
          <ButtonLink title='Cadastrar Grupo' link='/seguranca/grupos' icon={<BiChevronRight />} />
        </Grid>
        <Grid item>
          <ButtonLink
            title='Atribuir Permissão'
            link='/seguranca/permissoes'
            icon={<BiChevronRight />}
          />
        </Grid>
        <Grid item>
          <ButtonLink title='Importar Dados' link='/seguranca/importar' icon={<BiChevronRight />} />
        </Grid>
        <Grid item>
          <ButtonLink
            title='Fila de Processamento'
            link='/seguranca/processamento'
            icon={<BiChevronRight />}
          />
        </Grid>
      </GridComponent>
      <GridComponent spacing={2} margin='10px 0px'>
        <Grid item>
          <ButtonLink title='Usuário Loja Principal' link='/seguranca' icon={<BiChevronRight />} />
        </Grid>
        <Grid item>
          <ButtonLink
            title='Gerente de Loja'
            link='/seguranca/gerenteloja'
            icon={<BiChevronRight />}
          />
        </Grid>
        <Grid item>
          <ButtonLink
            title='Gerente Regional'
            link='/seguranca/gerenteregional'
            icon={<BiChevronRight />}
          />
        </Grid>
        <Grid item>
          <ButtonLink
            title='Diretor de Bandeira'
            link='/seguranca/diretorbandeira'
            icon={<BiChevronRight />}
          />
        </Grid>
      </GridComponent>
      <Card color='#fbfbfb' padding={'10px 20px'} margin='20px 0px 0px 0px'>
        <Grid item sm={12}>
          <Router />
        </Grid>
      </Card>
    </Container>
  );
}
